export default __webpack_public_path__ + "static/media/rupeepay.570d87a0.svg";